export class CollectionSortTrigger extends window.BAO.CustomElement({
  SuperClass: HTMLButtonElement,
}) {
  static get requiredAttributes () {
    return ['data-accordion', 'data-drawers-trigger']
  }

  connectedCallback () {
    super.connectedCallback()

    this.listeners.add(this, 'click', this.onClick.bind(this))
  }

  onClick (e) {
    if (!this.accordion) return
    if (!this.drawer) return

    e.preventDefault()
    e.stopPropagation()

    this.accordion.toggle(true)
    window.drawers.activeDrawerKey = this.drawer.key
  }

  get accordion () {
    return document.getElementById(this.getAttribute('data-accordion'))
  }

  get drawer () {
    return window.drawers.drawers.find(
      drawer => drawer.key === this.getAttribute('data-drawers-trigger'),
    )
  }
}

if (!customElements.get('collection-sort-trigger')) {
  customElements.define('collection-sort-trigger', CollectionSortTrigger, {
    extends: 'button',
  })
}
